import BaseServiceApiWCF from "BaseServiceApiWCF";
import BaseServiceApi from "BaseServiceApi";
import GetTransactionsDataRequest from "../Requests/GetTransactionsDataRequest";
import GetUserPortfoliosRequest from "../Requests/GetUserPortfoliosRequest";
import GetRoundTripDataRequest from "../Requests/GetRoundTripDataRequest";
import GetUnitCostNodesRequest from "../Requests/GetUnitCostNodesRequest";

class TransactionsApi {

    constructor() {
        this.builder = BaseServiceApiWCF.getBuilder();
        this.rayData = this.builder.build("RayChartCommon");
    }

    getUserPortfolios(endDate) {
        const request = new GetUserPortfoliosRequest(endDate)
        return BaseServiceApi.processAAServiceCall(request);
    }

    getTransactionsData(portfolioID, oid, currencyCode, startDate, endDate) {
        const getlong = true
        const getshort = true
        const request = new GetTransactionsDataRequest(portfolioID, oid, startDate, endDate, getlong, getshort, currencyCode);
        return BaseServiceApi.processAAServiceCall(request);
    }

    getUnitCostNodes(portfolioID, oid, currencyCode, startDate, endDate) {
        const getlong = true
        const getshort = true
        const request = new GetUnitCostNodesRequest(portfolioID, oid, startDate, endDate, getlong, getshort, currencyCode);
        return BaseServiceApi.processAAServiceCall(request);
    }

    getRoundTripData(portfolioID, osid, currencyCode, startDate, endDate) {
        const getlong = true
        const getshort = true
        const request = new GetRoundTripDataRequest(portfolioID, osid, startDate, endDate, getlong, getshort, currencyCode);
        return BaseServiceApi.processAAServiceCall(request);
    }
}

const transactionsApi = new TransactionsApi();
export default transactionsApi;
